import { render, staticRenderFns } from "./PayType.vue?vue&type=template&id=10a90e59&scoped=true"
import script from "./PayType.vue?vue&type=script&lang=js"
export * from "./PayType.vue?vue&type=script&lang=js"
import style0 from "./PayType.vue?vue&type=style&index=0&id=10a90e59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a90e59",
  null
  
)

export default component.exports